import Link from "next/link";
import Box from "@mui/material/Box";
import { ArrowForwardOutlined } from "@mui/icons-material";

import CustomTypography from "../UI/Typography/CustomTypography";
import CustomIconButton from "../UI/Button/CustomIconButton";

import { exploreCardStyles } from "./ExploreCard.styles";

interface ExploreCardProps {
    title: string;
    description?: string | null;
    imageUrl: string;
    href: string;
    onClick?: () => void;
}

const ExploreCard = ({
    title,
    description,
    imageUrl,
    href,
    onClick,
}: ExploreCardProps) => {
    const displayTitle = description ? `${title} ${description}` : title;

    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <Box
            component={Link}
            href={href}
            sx={exploreCardStyles.card}
            onClick={handleClick}
            aria-label={displayTitle}
        >
            {/* Background image with gradient fallback */}
            <Box
                component="img"
                src={imageUrl}
                alt=""
                sx={exploreCardStyles.image}
                onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                    // Hide the image on error, gradient background will show
                    e.currentTarget.style.opacity = "0";
                }}
            />

            {/* Gradient overlay with content */}
            <Box sx={exploreCardStyles.overlay}>
                <Box sx={exploreCardStyles.content}>
                    <CustomTypography sx={exploreCardStyles.title}>
                        {displayTitle}
                    </CustomTypography>
                </Box>

                <CustomIconButton
                    sx={exploreCardStyles.arrowButton}
                    aria-label={`Go to ${title}`}
                    tabIndex={-1}
                >
                    <ArrowForwardOutlined
                        sx={exploreCardStyles.arrowIcon}
                        style={{ fontSize: 20 }}
                    />
                </CustomIconButton>
            </Box>
        </Box>
    );
};

export default ExploreCard;